import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const usePowerBiReportsStore = defineStore('powerBiReports', {
  state,
  getters,
  actions
})

export default usePowerBiReportsStore
